import React, { Component } from 'react';
import ToolbarItem from '../../nav/toolbar/ToolbarItem';
import Modal from '../basic/Modal';
import ShareModal from './ShareModal';
import { ShareIcon } from '../../icons/ShareIcon';

interface Props {
  projectId: number;
  apiUrl?: string;
  userIsAdmin?: boolean;
}

interface State {
  showModal: boolean;
}

export class ShareAction extends Component<Props, State> {
  state = { showModal: false };

  shareIcon = (<ShareIcon fill="#007db8" />);

  openModal = () => {
    this.setState(state => {
      return {
        ...state,
        showModal: true,
      };
    });
  };

  closeModal = () => {
    this.setState(state => {
      return {
        ...state,
        showModal: false,
      };
    });
  };

  render() {
    return (
      <>
        <ToolbarItem
          text="Share"
          clickFn={this.openModal}
          icon={<ShareIcon width="18px" />}
        ></ToolbarItem>
        {this.state.showModal && (
          <Modal closeFn={this.closeModal} modalTitle={'Share Project'} modalIcon={this.shareIcon}>
            <ShareModal
              projectId={this.props.projectId}
              closeFn={this.closeModal}
              apiUrl={this.props.apiUrl}
              userIsAdmin={this.props.userIsAdmin}
            />
          </Modal>
        )}
      </>
    );
  }
}

export default ShareAction;
